import { TripBilling } from "../components/details-view/payments-data/types";
import { TripStatusEnum } from "../models/customer-data.interface";

export const TripPaymentState = {
    PAID: 'Paid',
    UNPAID: 'Unpaid',
    PRE_AUTH: 'PreAuth',
    WAIT_FOR_PRE_AUTH: 'Wait for PreAuth',
    REJECTED: 'Rejected',
    CANCELED: 'Canceled',
}

export const TripPaymentStateKeys = Object.keys(TripPaymentState);
export const TripPaymentStateValues = Object.values(TripPaymentState);

export type FilterTripHistoryPaymentState = keyof (typeof TripPaymentState) | 'ALL';
export type FilterPaymentState = keyof (typeof TripPaymentState) | null;

export const BillingEntryState = {
    PREAUTH: 'Preauth',
    PAID: 'Paid',
    UNPAID: 'Unpaid',
    REFUND_INITIATED: 'Refund initiated',
    REFUNDED: 'Refund successful',
    REFUND_REJECTED: 'Refund rejected',
}

export type FilterBillingEntryState = keyof (typeof BillingEntryState) | null;

export const BillingEntryStateKeys = Object.keys(BillingEntryState);
export const BillingEntryStateValues = Object.values(BillingEntryState);

export function getPaymentState(tripState: TripStatusEnum, items: (TripBilling)[], serviceProviderId: string, isTotalPaid: boolean) {
    switch (tripState) {
        case 'CANCELED':
            return (items.find(i => i.state === 'REJECTED') ? TripPaymentState.REJECTED :
                items.find(i => i.state === 'COMPLETED') ? TripPaymentState.PAID :
                    (items.find(i => i.state === 'AUTHORIZATION_HOLD') ? TripPaymentState.PRE_AUTH : TripPaymentState.CANCELED));
        case "UPCOMING":
        case "VEHICLE_READY":
        case "IN_TRIP":
        case "IN_STOPOVER":
            return (items.find(i => i.state === 'REJECTED') ? TripPaymentState.REJECTED :
                items.find(i => i.state === 'AWAITING_AUTHORIZATION') ? TripPaymentState.WAIT_FOR_PRE_AUTH :
                    (items.find(i => i.state === 'AUTHORIZATION_HOLD') ? TripPaymentState.PRE_AUTH : TripPaymentState.CANCELED))
        case "COMPLETED":
            if (serviceProviderId === 'Dott') {
                return items.find(i => i.state !== 'COMPLETED') ?
                    items.find(i => i.state !== 'CANCELED') ? TripPaymentState.UNPAID : TripPaymentState.CANCELED
                    : isTotalPaid ? TripPaymentState.PAID : TripPaymentState.UNPAID
            } else {
                return items.find(i => i.state !== 'COMPLETED') ?
                    items.find(i => i.state === 'CANCELED') ? TripPaymentState.CANCELED :
                        items.find(i => i.state === 'REJECTED') ? TripPaymentState.REJECTED :
                            TripPaymentState.UNPAID : isTotalPaid ? TripPaymentState.PAID : TripPaymentState.UNPAID
            }
    }
}

export function getFilterPaymentState(tripState: TripStatusEnum, items: TripBilling[], serviceProviderId: string, isTotalPaid: boolean): FilterPaymentState {
    const state = getPaymentState(tripState, items, serviceProviderId, isTotalPaid);

    const stateIndex = TripPaymentStateValues.findIndex(s => s === state);
    return TripPaymentStateKeys[stateIndex] as FilterPaymentState;
}
